import { ax } from 'src/client'
import { removeFalsyProperties } from 'src/utils'
import {
  APPROVE_PAYABLE_REQUEST,
  CANCEL_PAYABLE_REQUEST,
  GET_PAYABLE_DETAILS,
  GET_PAYABLE_LIST
} from './serviceURLS'

function getParamsToSend(params) {
  return removeFalsyProperties({
    offset: params.offset,
    limit: params.limit,
    descending: params.descending,
    sort_by: params.sortBy,
    client_name: params.clientName,
    client_country: params.clientCountry,
    partner_id: params.partnerId,
    total_requested_amount_from: params.amountFrom,
    total_requested_amount_to: params.amountTo,
    created_at_from: params.createdAtFrom,
    created_at_to: params.createdAtTo,
    state: params.state
  })
}

export function getPayables(params) {
  return ax.get(GET_PAYABLE_LIST, {
    params: getParamsToSend(params)
  })
}

export function getPayableDetails(id) {
  return ax.get(GET_PAYABLE_DETAILS.replace(':id', id))
}

export function approveEtp(id) {
  return ax.put(APPROVE_PAYABLE_REQUEST.replace(':id', id))
}

export function cancelEtp(id, cancel_reason) {
  return ax.put(CANCEL_PAYABLE_REQUEST.replace(':id', id), { cancel_reason })
}
